import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import { Icon, Row, Popconfirm, Tooltip } from "antd";

export default function RowTools({
  row,
  titleCapNhat,
  showEditModal,
  deleteRowModal,
  showMapModal,
  showDanhGiaModal,
  showPhanHoiModal,
  showFile,
  pheDuyet,
  guiPheDuyet,
  guiDeNghi,
  xacNhan,
  iconEdit,
  iconMap,
  iconDanhGia,
  iconDelete,
  iconFile,
  iconPheDuyet,
  iconDetail,
  showDetail,
  iconGuiPheDuyet,
  iconGuiDeNghi,
  iconXemPhanHoi,
  iconXacNhan,
  colorMap,
  iconReRoll,
  ReRoll,
  popconfirmInfor = {
    placement: 'top',
    title: "Xóa bản ghi này ?",
    okText: "Xóa",
    cancelText: "Hủy",
    onConfirm: () => deleteRowModal(row.id)
  }
}) {
  return (
    <Container type="flex" justify="center" align="middle" style={{ flexFlow: "row" }}>
      <Row type="flex" justify="space-between" align="middle" >
        {iconGuiPheDuyet ?
          <Tooltip placement="top" title="Trình phê duyệt">
            <CustomIcon
              color="#63c2de"
              type="audit"
              onClick={() => {
                guiPheDuyet(row);
              }}
              style={{ paddingRight: "2px", paddingLeft: "2px" }}
            />
          </Tooltip>
          : undefined
        }
        {iconPheDuyet ?
          <Tooltip placement="top" title="Phê duyệt">
            <CustomIcon
              color="#63c2de"
              type="audit"
              onClick={() => {
                pheDuyet(row);
              }}
              style={{ paddingRight: "2px", paddingLeft: "2px" }}
            />
          </Tooltip>
          : undefined
        }
        {iconXacNhan ?
          <Tooltip placement="top" title={titleCapNhat ? titleCapNhat : "Phê duyệt"}>
            <CustomIcon
              color="#63c2de"
              type="check"
              onClick={() => {
                xacNhan(row);
              }}
              style={{ paddingRight: "2px", paddingLeft: "2px" }}
            />
          </Tooltip>
          : undefined
        }
        {iconGuiDeNghi ?
          <Tooltip placement="top" title="Trình phê duyệt">
            <CustomIcon
              color="#63c2de"
              type="caret-right"
              onClick={() => {
                guiDeNghi(row);
              }}
              style={{ paddingRight: "2px", paddingLeft: "2px" }}
            />
          </Tooltip>
          : undefined
        }
        {iconMap ?
          <Tooltip placement="top" title="Bản đồ">
              <CustomIcon color={colorMap ? "#a7a8a8" : "#63c2de"} type="global" onClick={() => {
                colorMap ? console.log("") :
                  showMapModal(row);
              }}
                style={{ paddingRight: "2px", paddingLeft: "2px" }}
              />
          </Tooltip>
          : undefined
        }
        {iconDanhGia ?
          <Tooltip placement="top" title="Đánh giá mẫu quan trắc">
            <CustomIcon color="#63c2de" type="check-square" onClick={() => {
              showDanhGiaModal(row);
            }}
              style={{ paddingRight: "2px", paddingLeft: "2px" }}
            />
          </Tooltip>
          : undefined
        }
        {iconXemPhanHoi ?
          <Tooltip placement="top" title="Xem phản hồi">
            <CustomIcon color="#63c2de" type="message" onClick={() => {
              showPhanHoiModal(row);
            }}
              style={{ paddingRight: "2px", paddingLeft: "2px" }}
            />
          </Tooltip>
          : undefined
        }
        {iconFile ?
          <Tooltip placement="top" title="Xem file">
            <CustomIcon
              color="#63c2de"
              type="file-pdf"
              onClick={() => {
                showFile(row);
              }}
              style={{ paddingRight: "2px", paddingLeft: "2px" }}
            />
          </Tooltip>
          : undefined
        }
        {iconDetail ?
          <Tooltip placement="top" title="Xem chi tiết">
            <CustomIcon
              color="#63c2de"
              type="info-circle"
              onClick={() => {
                showDetail(row);
              }}
              style={{ paddingRight: "2px", paddingLeft: "2px" }}
            />
          </Tooltip>
          : undefined
        }
        {iconEdit ? undefined :
          <Tooltip placement="top" title="Sửa">
            <CustomIcon
              color="#63c2de"
              type="edit"
              onClick={() => {
                showEditModal(row);
              }}
              style={{ paddingRight: "2px", paddingLeft: "2px" }}
            />
          </Tooltip>
        }
        {iconDelete ? undefined :
          <>
            {popconfirmInfor ?
              <Tooltip placement="top" title="Xóa">
                <Popconfirm placement={popconfirmInfor.placement} title={popconfirmInfor.title}
                  onConfirm={() => popconfirmInfor.onConfirm()}
                  onCancel={() => popconfirmInfor.onCancel ? popconfirmInfor.onCancel() : undefined}
                  okText={popconfirmInfor.okText} cancelText={popconfirmInfor.cancelText}>
                  <CustomIcon color="red" type="delete" />
                </Popconfirm>
              </Tooltip>
              :
              <Tooltip placement="top" title="Xóa">
                <CustomIcon color="red" type="delete" onClick={() => {
                  deleteRowModal(row);
                }} />
              </Tooltip>
            }
          </>
        }
         {iconReRoll ?
          <Tooltip placement="top" title="Sử dụng dữ liệu của phiên bản này">
            <Popconfirm placement="top" title="Bạn có muốn sử dụng dữ liệu của phiên bản cũ"
              onConfirm={() => ReRoll(row)}
              onCancel={() => undefined}
              okText="Có" cancelText="Không">
              <CustomIcon color="#63c2de" type="undo" />
            </Popconfirm>
          </Tooltip>
          : undefined
        }
      </Row>

    </Container>
  );
}

RowTools.propTypes = {
  row: PropTypes.object.isRequired,
  showEditModal: PropTypes.func.isRequired,
  deleteRowModal: PropTypes.func.isRequired,
};

const Container = styled(Row)`
  // max-width: 50px;
`;

const CustomIcon = styled(Icon)`
  font-size: 16px;
  cursor: pointer;
  color: ${props => props.color} !important;
`;
